export default __webpack_public_path__ + "static/media/Logo_Home.c7890a6a.png";